import { Controller } from "@hotwired/stimulus"

// Synchronizes sidebar notification indicators with the mobile hamburger control.
export default class extends Controller {
  static identifier = "sidebar-notifications"
  static targets = ["badge"]

  connect() {
    this.sidebarElement = null
    this.observer = null

    this.ensureSidebar()

    this.update()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  setupObserver() {
    this.observer = new MutationObserver(() => this.update())
    this.observer.observe(this.sidebarElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["class"]
    })
  }

  update() {
    this.ensureSidebar()

    if (!this.hasBadgeTarget) return

    if (this.sidebarHasNotification()) {
      this.badgeTarget.classList.remove("hidden")
    } else {
      this.badgeTarget.classList.add("hidden")
    }
  }

  sidebarHasNotification() {
    if (!this.sidebarElement) return false

    const selectors = ['[data-role="achievement-indicator"]', '[data-role="upgrade-indicator"]']

    return selectors.some((selector) => {
      const element = this.sidebarElement.querySelector(selector)
      return element && !element.classList.contains("hidden")
    })
  }

  ensureSidebar() {
    const currentSidebar = document.querySelector(".drawer-side")

    if (currentSidebar === this.sidebarElement) return

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    this.sidebarElement = currentSidebar

    if (this.sidebarElement) {
      this.setupObserver()
    }
  }
}
